// Helpers for the React Native / WebView bridge used when the game is
// embedded inside the ExtraMile mobile app. Activated via the
// `?fromMobileApp=true` URL parameter on /login, then persisted into
// userData so every page can detect it without re-reading the URL.

export function isFromMobileApp(user) {
  if (user && typeof user.fromMobileApp === "boolean") return user.fromMobileApp;
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return false;
    return Boolean(JSON.parse(raw)?.fromMobileApp);
  } catch {
    return false;
  }
}

export function postMobileNavigateBack() {
  try {
    window?.GameStatus?.postMessage?.("navigate_back");
  } catch {
    // ignore: bridge not injected
  }
}
